import React from 'react'
import Blogs from '../components/blog/blogs'

import Navbar from '../components/common/navbar'
import Footer from '../components/common/footer'


const BlogPage = () => {
    return (
        <>
            <Navbar />
            <Blogs />
            <Footer />
        </>
    )
}

export default BlogPage